import { SelectOptionData } from '../../../../../../../Pi/types'
import { NodeMessageEditorProps } from '../../../types'

export type ForwardMessageNodeProps = NodeMessageEditorProps & {
  admins: Array<SelectOptionData>
  targets: Array<SelectOptionData>
}

export enum SendMessageMode {
  Forward = 'Forward',
  Copy = 'Copy',
}
